import type {ReactElement} from 'react';
import React from 'react';
import {PosterEditingBaseColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-color-panel';
import {getColorFillTypeFromFillType, getColorObjectArrayFromFillColor, getFillTypeFromColorFillType, getRGBAArrayFromColorStorage} from '@Utils/color.util';
import {useGetSelectedTranscriptItem} from '@Hooks/poster-editor/useGetSelectedTranscriptItem';
import type {ColorStorage} from '@Components/color-picker-v2';
import type {ColorFillPropertyType} from '@Components/color-fill';
import {useGetKeyFromFillOfSubtitleTextStylesForTranscriptItem} from '@Hooks/poster-editor/useGetKeyFromFillOfSubtitleTextStylesForTranscriptItem';

export function TranscriptSentenceTextColorPanel(): ReactElement<any> {
  const activeItem = useGetSelectedTranscriptItem();
  if (activeItem === null) {
    throw new Error('Transcript Item is undefined in TranscriptSentenceTextColorPanel');
  }

  const fillType = useGetKeyFromFillOfSubtitleTextStylesForTranscriptItem('fillType');
  if (fillType === undefined) {
    throw new Error('Transcript item subtitle objects do not have fillType property in their sentenceTextStyles object');
  }

  const fillColor = useGetKeyFromFillOfSubtitleTextStylesForTranscriptItem('fillColor');
  if (fillColor === undefined) {
    throw new Error('Transcript item subtitle objects do not have fillColor property in their sentenceTextStyles object');
  }

  const onSentenceTextColorChange = (updatedColor: ColorStorage[]): void => {
    void activeItem.updateAllSubtitlesStylesFromSubtitleObject(
      {
        sentenceTextStyles: {
          fill: {
            fillColor: getRGBAArrayFromColorStorage(updatedColor),
          },
        },
      },
      {undoable: false}
    );
  };

  const onSentenceTextColorChangeEnded = (updatedColor: ColorStorage[]): void => {
    void activeItem.updateAllSubtitlesStylesFromSubtitleObject({
      sentenceTextStyles: {
        fill: {
          fillColor: getRGBAArrayFromColorStorage(updatedColor),
        },
      },
    });
  };

  const onSentenceTextColorTypeChanged = (newType: ColorFillPropertyType): void => {
    if (getFillTypeFromColorFillType(newType) === fillType) {
      return;
    }

    void activeItem.updateAllSubtitlesStylesFromSubtitleObject({
      sentenceTextStyles: {
        fill: {
          fillType: getFillTypeFromColorFillType(newType),
          fillColor: activeItem.getAnySubtitle().sentenceTextStyles.fill.getColorForNewType(getFillTypeFromColorFillType(newType)),
        },
      },
    });
  };

  return (
    <PosterEditingBaseColorPanel
      id="transcript-sentence-text-fill-color-panel"
      color={getColorObjectArrayFromFillColor(fillColor)}
      onChangeColor={onSentenceTextColorChange}
      onChangeEnded={onSentenceTextColorChangeEnded}
      onChangeType={onSentenceTextColorTypeChanged}
      isGradientEnabled
      type={getColorFillTypeFromFillType(fillType)}
    />
  );
}
